import { useEffect, useRef, useState } from 'react';

import { isTabletOrMobile } from '@genially/ui';

import { usePlayerGameContext } from '../../PlayerGame.context';
import { FlapButton } from './components/FlapButton/FlapButton';
import { RaiseHand } from './components/RaiseHand/RaiseHand';
import { Reactions } from './components/Reactions/Reactions';
import {
  ContentWrapper,
  RaiseHandWrapper,
  ReactionsWrapper,
  Wrapper,
} from './ReactionBar.styled';

const INITIAL_HIDE_DELAY_MS = 5000;
const HIDE_DELAY_MS = 2000;

export const ReactionBar = () => {
  const { reactionsEnabled, raiseHandEnabled, isMouseNearBottom, isCountdownHidden } =
    usePlayerGameContext();

  const [isVisible, setIsVisible] = useState(true);
  const hasBeenHiddenBefore = useRef(false);
  const [isBarOpen, setIsBarOpen] = useState(false);

  useEffect(() => {
    if (isTabletOrMobile) {
      setIsVisible(true);
      hasBeenHiddenBefore.current = false;
      return;
    }
    if (!reactionsEnabled && !raiseHandEnabled) return;
    if (!isCountdownHidden) return;

    if (isMouseNearBottom) {
      setIsVisible(true);
      return;
    }

    const delay = hasBeenHiddenBefore.current ? HIDE_DELAY_MS : INITIAL_HIDE_DELAY_MS;
    const timer = setTimeout(() => {
      setIsVisible(false);
      hasBeenHiddenBefore.current = true;
    }, delay);
    return () => clearTimeout(timer);
  }, [reactionsEnabled, raiseHandEnabled, isCountdownHidden, isMouseNearBottom]);

  useEffect(() => {
    if (!isTabletOrMobile) {
      setIsBarOpen(false);
    }
  }, []);

  const featuresActive = (reactionsEnabled || raiseHandEnabled) && isCountdownHidden;
  const barVisible = isTabletOrMobile
    ? isBarOpen && featuresActive
    : isVisible && featuresActive;
  const flapVisible = isTabletOrMobile && featuresActive;

  if (!featuresActive) {
    return null;
  }

  return (
    <Wrapper $visible={barVisible} $isMobile={isTabletOrMobile}>
      {flapVisible && (
        <FlapButton isOpen={isBarOpen} onClick={() => setIsBarOpen(v => !v)} />
      )}

      <ContentWrapper>
        <ReactionsWrapper $visible={reactionsEnabled}>
          <Reactions />
        </ReactionsWrapper>
        <RaiseHandWrapper $visible={raiseHandEnabled}>
          <RaiseHand />
        </RaiseHandWrapper>
      </ContentWrapper>
    </Wrapper>
  );
};
